import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SupportserviceService } from '../supportverificationcationmodal/supportservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-loginsecuritymodal',
  templateUrl: './loginsecuritymodal.component.html',
  styleUrls: ['./loginsecuritymodal.component.css']
})
export class LoginsecuritymodalComponent {
  loginid='';
  logindatetime=[{
    successdate1:'',
    sucessdate2:'',
    faildate1:'',
    faildate2:''
  }]
  logindetails:any={}

  constructor(  public ref: DynamicDialogRef,private supporservice:SupportserviceService,private config: DynamicDialogConfig, private spinnerservice: NgxSpinnerService){
        const dataFromParent = this.config.data;
        this.logindetails=dataFromParent
         this.loginid=dataFromParent.loginid

    this.getloginmessage(dataFromParent.loginid);
    this.gettraininglink()
  }
  okandgo(){
this.ref.close()
  }
  loginInfo:any;
    trainigdata=[]

  gettraininglink(){
    this.supporservice.traininglink().subscribe(res=>{
      this.trainigdata=res
      
    })
  }

  getloginmessage(loginid){
this.supporservice.getlogininformation(loginid).subscribe(res => {
  const logindata = res.logindata || [];
  const trainingdata = res.trainingdata || [];
  let successdate1 = '';
  let successdate2 = '';
  let faildate1 = '';
  let faildate2 = '';
  let training = trainingdata[0]?.messagename || '';
  const successes = logindata.filter(x => x.type === 'Successful');
  const fails = logindata.filter(x => x.type === 'Fail');
  if (successes.length > 0) successdate1 = successes[0].log_time;
  if (successes.length > 1) successdate2 = successes[1].log_time;

  if (fails.length > 0) faildate1 = fails[0].log_time;
  if (fails.length > 1) faildate2 = fails[1].log_time;

  this.loginInfo = {
    successdate1,
    successdate2,
    faildate1,
    faildate2,
    training
  };
});
  }
  invteemail(){
    this.spinnerservice.show()
    const payload={userid:this.logindetails.email}
    this.supporservice.trainingemaillink(payload).subscribe(res=>{
      this.spinnerservice.hide();
      console.log(res);
      if(res.response=='success'){
          Swal.fire({icon: "success",title: "Training invitation link has been sent to your Email Inbox."});
      }

      
    },error=>{
            this.spinnerservice.hide();
    })

  }
}
